<template>
    <div v-wechat-title="title">
        <!-- <CloseButton type="close" msg="closeWindow" :title="title"></CloseButton> -->
        <div style="margin: 5px" v-if="freeRoomsList.length > 0">
            <el-button size="mini" v-for="item in freeRoomsList" :key="item.value" type="primary" plain @click="loadSlectedRoom(item)" style="margin: 10px">{{ item.label }}</el-button>
        </div>
        <div class="noRoomTitle" v-else>暂无可用手术间</div>
        <CloseButton style="position: fixed; bottom: 0px; right: 10px" type="confirm" @confirm="exchangeRoom" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `ExchangeRoom`,
    props: {},
    data() {
        return {
            title: `更换手术间`,
            token: this.$route.query.token,
            freeRoomsList: [],
            exchangeRoomItem: [],
            data: {},
            msg: `closeWindow`
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.loadFreeRooms()
    },
    computed: {},
    methods: {
        loadFreeRooms() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetFreeRooms`, { surgeryId: this.$route.query.surgery_id })
                req.then(data => {
                    this.freeRoomsList = data
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadSlectedRoom(item) {
            this.exchangeRoomItem = item
        },
        exchangeRoom() {
            if (this.exchangeRoomItem.value === undefined || this.exchangeRoomItem.value === ``) {
                this.$message.warning(`选择需要更换的手术间`)
                return false
            }
            return new Promise(resolve => {
                let req = this.myaxios.put(`/api/Intraoperative/Anaesthesia/ExchangeRoom`, {
                    id: this.$route.query.surgery_id,
                    dic_operating_room_id: this.exchangeRoomItem.value,
                    dic_operating_room: this.exchangeRoomItem.label
                })
                req.then(data => {
                    this.data = { surgeryId: this.$route.query.surgery_id }
                    this.msg = `ok`
                    this.sendMessage()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {}
}
</script>
<style scoped>
.noRoomTitle {
    height: 200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: justify;
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/ExchangeRoom.vue